import Vue from "vue";
import Cookies from "js-cookie";

export default {
  setLanguage(language) {
    Cookies.set("language", language, { expires: 365 });
    window.app.$i18n.locale = language;
  },
};
